import type { ReactNode } from 'react'

import { useTheme } from '@emotion/react'

import { useBreakpoint } from '@twistopayments/design-system/hooks'

import * as styles from './text-button.styles'
import type { Sizes } from './text-button.styles'

type Props = {
  size: Sizes
  noTypography: boolean
  children: ReactNode
}

export const TextButtonTypography = ({
  size,
  noTypography,
  children,
}: Props) => {
  const isDesktop = useBreakpoint('mdUp')
  const theme = useTheme()

  if (noTypography) {
    return <>{children}</>
  }

  return (
    <span css={styles.typography(theme, size, isDesktop)}>{children}</span>
  )
}
